import { type ReactElement } from 'react';

import SpinnerIcon from '~/public/assets/images/svg/loader-spinner-icon.svg';

export default function ProductLoadingSpinner(): ReactElement {
  return (
    <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 transform">
      <SpinnerIcon className="h-14 w-14 animate-spin text-secondary-300" />
    </div>
  );
}
